module.exports = __webpack_public_path__ + "img/pika.34c14d29.webp";